import React, { useState,useEffect } from "react";
import TotalViewHours, { RefreshTime } from "./TotalViewHours";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import HistoryToggleOffOutlinedIcon from "@mui/icons-material/HistoryToggleOffOutlined";
import TopContentPieChart from "./PieChart/ContentPiechart";
import "../../Styles/contentDashboard.scss";
import MovieDetailTable from "./MovieDetailTable/movieDetailTable";
import HeaderComp from "../HeaderComponent/HeaderComp";
import PeriodFilter from "./Filters/PeriodFilter";
import RegionFilter from "./Filters/RegionFilter";
import { getCountries } from "../../redux/reducers/countriesReducer";
import { useDispatch, useSelector } from "react-redux";
import { watchedHoursMetrics } from "../../redux/reducers/watchedHoursMetricsReducer";
import { topContentViews } from "../../redux/reducers/topContentByViewsReducer";
import { watchedHoursGrid } from "../../redux/reducers/watchedHoursGridReducer";
import LoadingSpinner from "../LoadingSpinner";
import DatePickerFilter from "./Filters/DatePicker";
import MovieList from "./Filters/MovieList";
import { getMovies } from "../../redux/reducers/moviesListReducer";
import CircularProgress from "@mui/material/CircularProgress";

export default function ContentDashboard() {
  let dispatch = useDispatch();
  useEffect(() => {
    dispatch(getCountries({dispatch}));
    dispatch(getMovies({dispatch}));
  },[dispatch]);
  const [dateRange, setDateRange] = useState([null, null]);
  const [pageNumber, setPageNumber] = React.useState(1);
  const [title, setTitle] = React.useState("");
  const [selectedCountry, setSelectedCountry] = React.useState("");
  function onMoviesChange(movieId){
    const moviesListPayload={
      videoContentId: movieId,
      countryIds:""
    }
    if(movieId !==""){
      dispatch(watchedHoursMetrics(moviesListPayload))  
    }
    else{
      dispatch(watchedHoursMetrics())
    }
  }
  function formatToLocalDate(date) {
    if (!date) return "";
    const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
    return localDate.toISOString().split("T")[0];
  }
  function onDataChange(date, country) {
    const startDate = date[0] ? formatToLocalDate(date[0]) : "";
    const endDate = date[1] ? formatToLocalDate(date[1]) : "";
    const payload = {
      countryIds: country != null && country !== "" ? country : "",
      startDate: startDate, 
      endDate: endDate, 
    }
    
    const gridPayload={
    countryIds: country != null && country !== "" ? country : "",
    startDate: startDate, 
    endDate: endDate, 
    pageNumber:1,
    limit:10
    }

    
    if(payload.startDate !=="" && payload.endDate !== ""){
      dispatch(topContentViews(payload))
      dispatch(watchedHoursGrid({payload: gridPayload}))
    }
    setPageNumber(1);

  }

  function onPageChange(page) {
    const startDate = dateRange[0] ? formatToLocalDate(dateRange[0]) : "";
    const endDate = dateRange[1] ? formatToLocalDate(dateRange[1]) : "";
    const gridPayload={
      countryIds: selectedCountry != null && selectedCountry !== "" ? selectedCountry : "",
      startDate: startDate, 
      endDate: endDate, 
      pageNumber:page,
      title: title,
      limit:10
    }
    dispatch(watchedHoursGrid({payload: gridPayload,initialRequest: false}));
    setPageNumber(page)

  }

  function onSearchChange(title) {
    setTitle(title);
    setPageNumber(1);
    const startDate = dateRange[0] ? formatToLocalDate(dateRange[0]) : "";
    const endDate = dateRange[1] ? formatToLocalDate(dateRange[1]) : "";
    const gridPayload={
      countryIds: selectedCountry != null && selectedCountry !== "" ? selectedCountry : "",
      startDate: startDate, 
      endDate: endDate, 
      pageNumber:0,
      title: title,
      limit:10
    }
    dispatch(watchedHoursGrid({payload: gridPayload}));
  }
  function onDateChange(date) {
    setDateRange(date);
    onDataChange(date, selectedCountry);
  }
  function onCountryChange(country) {
    setSelectedCountry(country);
    onDataChange(dateRange, country);
  }
  function onMovieChange(movieId){
    onMoviesChange(movieId)
  }
  useEffect(()=>{
    dispatch(watchedHoursMetrics())  
  },[dispatch])
  const watchedHoursMetricsData = useSelector(
    (state) => state.watchedHourMetricsRes?.getWatchedHoursMetricsReq?.response
  );
  const watchedHoursMetricsLoading = useSelector(
    (state)=>state.watchedHourMetricsRes?.iswatchedHoursMetricsLoading
  )
  
  const formatDuration = (hoursWatched) => {
    const totalSeconds = Math.round(hoursWatched * 3600);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    if(totalSeconds===0){
      return 0
    }
    const parts = [];
    if (hours > 0) parts.push(`${hours}h`);
    if (minutes > 0) parts.push(`${minutes.toString().padStart(2, '0')}m`);
    parts.push(`${seconds.toString().padStart(2, '0')}s`);
  
    return parts.join(" ");
  };
  return (
    <>
      <HeaderComp />
      {!watchedHoursMetricsData ? <LoadingSpinner/>:
      <div className="pageContainer">
        <div className="contentHeader">
          <div className="pageTitle">Content Analytics</div>
        </div>

        <div className="mainContainer">
          <div className="piechartContainer">
            <div style={{width:"100%"}}>
            <div className="filter">
              <PeriodFilter dateRange={dateRange} setDateRange={onDateChange} />
              <DatePickerFilter dateRange={dateRange} setDateRange={onDateChange} />
              <RegionFilter onCountryChange={onCountryChange} />
            </div>
            <TopContentPieChart />
            <MovieDetailTable setPageNumber={onPageChange} pageNumber={pageNumber} onSearchChange={onSearchChange} />
          </div>

        </div>
            
          <div className="container-div">
           
          <div className="totalViewHours">
          <RefreshTime value={watchedHoursMetricsData?.lastRefreshedDate} />
          <MovieList onMovieChange={onMovieChange} />

          {watchedHoursMetricsLoading || !watchedHoursMetricsData ? (
            <div
            style={{width:"80%",textAlign:"center"}}
            >
              <CircularProgress size={34} />
            </div>
    ) : (
      <>
        <TotalViewHours
          title="Total view so far"
          value={watchedHoursMetricsData?.totalView}
          percentage={17}
          description="From last month"
          icon={<VisibilityOutlinedIcon />}
        />
        <TotalViewHours
          title="Total watched hours so far"
          value={
            watchedHoursMetricsData?.totalWatchedHours != null
              ? formatDuration(watchedHoursMetricsData.totalWatchedHours)
              : ""
          }
          percentage={17}
          description="From last month"
          icon={<HistoryToggleOffOutlinedIcon />}
        />
        <TotalViewHours
          title="Total view last month"
          value={watchedHoursMetricsData?.totalViewLastMonth}
          percentage={-17}
          description="From last month"
          icon={<VisibilityOutlinedIcon />}
        />
        <TotalViewHours
          title="Total hours watched last month"
          value={
            watchedHoursMetricsData?.totalWachedHoursLastMonth != null
              ? formatDuration(watchedHoursMetricsData.totalWachedHoursLastMonth)
              : ""
          }
          percentage={17}
          description="From last month"
          icon={<HistoryToggleOffOutlinedIcon />}
        />
      </>
    )}
          </div>

            </div>
        </div>
      </div>
}
    </>
  );
}
